import { BareActionContext } from 'vuex-typex'
import { StatementState } from '@/store/statement/state'
import { RootState } from '@/store'
import statementStore from '@/store/statement/statement-store'
import setStatementQuery from '@/store/statement/actions/set-statement-query'
import feedStore from '@/store/feed/feed-store'
import { StatementSearchForm } from '@/model/search/search-query'

export default async function initFetchStatements(context: BareActionContext<StatementState, RootState>)
{
    statementStore.state.statements = []
    statementStore.state.statementSearchForm = new StatementSearchForm()
    const form = statementStore.state.statementSearchForm
    if (!feedStore.isCurrentUser) {
        form.jybedByUser = true
    }

    setStatementQuery(context)

    return
}
